// Theme Colors
export const PRIMARY = '#54d4f8';
export const BG_LIGHT = '#f5f8f8';
export const BG_DARK = '#101e22';
export const TERMINAL_GREEN = '#4ade80';

// Common style utilities
export const cn = (...classes: (string | false | undefined | null)[]) =>
  classes.filter(Boolean).join(' ');
